(function ($, konto) {
    var Sifarnik = function (unique, options) {
    	var that = this;
        konto.KontoBase.call(that, unique);
        // Id pod kojim je nastao šifarnik.
        that.id = "sif-" + unique;
        // div šifarnika
        that.div = $("#" + this.id);
        that.mainGrid = that.$(".main-grid");
        that.grid = this.mainGrid;
        that.controllerName = "";
        that.actionName = "";
        that.isSifarnik = false;
        that.noviObject = null;
        that.title = "";
        that.getFilter = null;
        that.columns = [];
        that.isModal = false;
        that.snimitiCache = true;
		that.gridArray = [];
        
        //this.filterPanel = null;
        
        $.extend(that, options);

		$("body").on("sifarnikloaded." + unique, function() {
			if (that._ajaxAsync === true)
				that._ajaxQueue.start();
		});
		
        // AJAX navigation -  više puta se poziva.
        $(window).on(that.getEventName("beforeunload") + " " + that.getEventName("beforepageunload"), that.saveGridValues.bind(that));
      
        // Kada nije pozvan kao sifarnik, onda smijem zapamtiti lokaciju.
        if (that.isSifarnik === false) {
            that._zapamtiSifarnikLokaciju();
        }
    };
    
    konto.Sifarnik = Sifarnik;
    konto.Sifarnik.prototype = Object.create(konto.KontoBase.prototype);
    konto.Sifarnik.prototype.constructor = Sifarnik;
    
    konto.Sifarnik.prototype = $.extend(konto.Sifarnik.prototype, {
        // U cookie sprema lokaciju šifarnika.
        _zapamtiSifarnikLokaciju: function () {
            // Pamtim zadnju sifarnik lokaciju.  
            var izboriId = $("#izboriId").html(); 
            var izboriNewTabId = $('body').data('izboriNewTabId');                  
           	var sifarnikLinkName = "SifarnikLink_" + izboriId + '_' + izboriNewTabId;           
            KUtils.SetSifarnikLink(sifarnikLinkName, JSON.stringify({       
                link: kontorouter.getHref(),
                controller: this.controller,
                action: this.actionName,
                baseAction: this.baseActionName,
                relative: this.controller + "/" + this.baseActionName
            }));
        },
        getSifarnikButtons: function (options) {
            var that = this;        
            var sifButtons = [{
                    name: "Odaberi",
                    ikona: "fa fa-check",
					id: "OdaberiButton_" + this.unique,
                    requiresSelectedRow: true,
                    click: function () {
                        that.kontoGrid.grid.select().trigger("dblclick");
                    }
                }, {
                    name: "Odustani",
                    ikona: "fa fa-times",  
					id: "OdustaniButton_" + this.unique,                  
                    click: function () {
                        var p = that.div.closest("[data-role=kontomodal]");
                        var wnd = p.data("kendoKontoModal");
                        wnd.close();
                    }
                }];
            return sifButtons;
        },
        getSelectedData: function () {
            return this.grid.kendoKontoGrid("getSelectedData");
        },
        getCacheKey: function (suffix) { 
            var key = this.cachePrefix + "-" + this.controllerName + "-" + this.baseActionName;
            if (typeof suffix === "undefined") {
                suffix = "";
                var s = this.kontoGrid.options.cacheSuffix;
                if (s)
                    suffix = s;
            }
            if (suffix != "") {
                key += "-" + suffix;
            }
            return key;
        },
		// Izbaciti old nakon nekog vremena?
        getCacheKeyOld: function (suffix) { 
            var key = this.cachePrefixOld  + "-" + this.controllerName + "-" + this.baseActionName;
            if (typeof suffix === "undefined") {
                suffix = "";
                var s = this.kontoGrid.options.cacheSuffix;
                if (s)
                    suffix = s;
            }
            if (suffix != "") {
                key += "-" + suffix;
            }
            return key;
        },
        // Vraća vrijednosti koje smo spremili u cache. 
        // Pretpostavljam da kod otvaranja šifarnika to neće biti potrebno.
        getValuesFromCache: function (suffix) {
            try {
                if (typeof suffix === "undefined")
                    suffix = "";
                var val = simpleStorage.get(this.getCacheKey(suffix));
                if (typeof val === "undefined"){
					val = simpleStorage.get(this.getCacheKeyOld(suffix));
					if (typeof val === "undefined"){	
						return {};  				
					}
					else{
						simpleStorage.set(this.getCacheKey(suffix), val);
					}		
				}             
                return val;
            } catch (e) { return {}; }  
        },
        getRowCache: function (suffix) {
            return this.getValuesFromCache(suffix);
        },
        saveGridValues: function () {
			if(this.gridArray){
				for(gridIndex=0; gridIndex<this.gridArray.length; gridIndex++){
					try {
						var values = $(this.gridArray[gridIndex].element[0]).kendoKontoGrid("getGridValues");
						
						//dodatak za formatiranje datuma, jer simpleStorage.set(key, values); simpleStorage.get(key); daje različite values  
						var pom = [];
						$.each(values.columns, function(keyV, valueV){
							if (typeof valueV == "object"){
								pom.push(keyV)
							}
						});
						
						for (var i=0; i<pom.length; i++){
							try{
								values.columns[pom[i]] = KUtils.formatDate(values.columns[pom[i]]);		
							} catch (e) {  } 
						}
						//za datume u filterima
						this.gridArray[gridIndex]._fixDates(values.grid.filters);
						if(this.snimitiCache){
							var key = this.getCacheKey(this.gridArray[gridIndex].options.cacheSuffix);
							if (values !== null) { 
								simpleStorage.set(key, values);
							}
							else {
								simpleStorage.deleteKey(key);
							}                
						}	
					} catch (e) { }
				}
			}
        },
        applayRowCSS: function (data, rowEl) { // primjer: COLOR=32768;APPLY_COLOR=FONT;FSTYLE=italic;
            if (data && (data != '')) {
                if (data.indexOf("COLOR") >= 0) {
                    var PozStart = data.indexOf("COLOR") + 6;
                    var PozEnd = data.indexOf(";", PozStart);
                    var Value = data.substring(PozStart, PozEnd);

                    var Prop = 'color';
                    if (data.indexOf("APPLY_COLOR") >= 0) {
                        var PozStart = data.indexOf("APPLY_COLOR") + 12;
                        var PozEnd = data.indexOf(";", PozStart);
                        if (data.substring(PozStart, PozEnd) != 'FONT') {
                            var Prop = 'background-color'; 
                        }
                    }
                    if (Value.trim() != '') {
	                    	if (Value.indexOf("#") >= 0){
	                    		var BojaWeb = Value;	
	                    	}else{
	                        	var BojaWeb = KUtils.intToCssDelphi(Value);
	                        }
                        rowEl.css(Prop, BojaWeb);
                        } 
                }
                if (data.indexOf("FSTYLE") >= 0) {
                    var PozStart = data.indexOf("FSTYLE") + 7;
                    var PozEnd = data.indexOf(";", PozStart);
                    var Value = data.substring(PozStart, PozEnd);
                    if (Value == 'italic') {
                        rowEl.css('font-style', Value);
                    }
                    if (Value == 'bold') {
                        rowEl.css('font-weight', Value);
                    }
                    if ((Value == 'line-through') || (Value == 'underline') ) {
                        rowEl.css('text-decoration', Value);
                    }                    
                }
                if (data.indexOf("FONT_STYLE") >= 0) {
                    var PozStart = data.indexOf("FONT_STYLE") + 11;
                    var PozEnd = data.indexOf(";", PozStart);
                    var Value = data.substring(PozStart, PozEnd);
                    if(Value.indexOf("B") > -1){
                    	rowEl.css('font-weight', 'bold');	
                    }
                    if(Value.indexOf("I") > -1){
                    	rowEl.css('font-style', 'italic');	
                    }
                    if(Value.indexOf("U") > -1){
                    	rowEl.css('text-decoration', 'underline');	
                    }
                    if(Value.indexOf("S") > -1){
                    	rowEl.css('text-decoration', 'line-through');	
                    }    
                    if((Value.indexOf("U") > -1) && (Value.indexOf("S") > -1)){
                    	rowEl.css('text-decoration', 'underline line-through');	
                    }                                   
                }                
                //dodajem jer mi zbog zpisa ne odgovara da šaljem još i apply_color property
                if (data.indexOf("BACKGROUND-COLOR") >= 0) {
                    var PozStart = data.indexOf("BACKGROUND-COLOR") + 17;
                    var PozEnd = data.indexOf(";", PozStart);
                    var Value = data.substring(PozStart, PozEnd);

                    var Prop = 'background-color';
                    if (Value.trim() != '') {
	                    	if (Value.indexOf("#") >= 0){
	                    		var BojaWeb = Value;	
	                    	}else{
	                        	var BojaWeb = KUtils.intToCssDelphi(Value);
	                        }
                        rowEl.css(Prop, BojaWeb);
                        } 
                }
            }
        },
        /**
         * Funkcija koja vraća funkciju koja će odraditi preusmjerenje na novi link u normalnom načinu rada ili
         * otvoriti novi prozor u browseru kod šifarnik načina rada.
         *
         * Params:
         * link - kamo treba ići (otvoriti prozor novi ili preusmjeriti)
         * data - dodatni podaci (više se ne koristi)
         */
        getGotoFunction: function (link) {
            var that = this;
            if (that.isModal) { //isSifarnik
                return function () {
		        	if (typeof link == "function"){
		        		link = link();
		        	}
                    var w = konto.dialogs.modal({
                        template: kontorouter.getModulPath(link),
                        id: that._getModalIdFromLink(link),
                        width: "85%",
                        templateLoaded: function () {
                            // Na formi se dogodi ovaj event prilikom upisa.
                            $("form", w.element).on("onUpis", function (event, data) {
                            	if (that.isSifarnik) {
	                                if (data) {
	                                    var newData = $.dsObjectToJS(data);
	                                    that.div.trigger("onOdabir", newData);
	                                }
                               	}
                               	else {
                               		if (data){
                               			that.kontoGrid.options.noviObject = $.dsObjectToJS(data);
                               		}
        							that.kontoGrid.grid.dataSource.read();	
                               	}
                                w = null; // GC
                            });
                        } 
                    })
                };  
            }
            else {
                return function () {
                    var l = link;
                    if (typeof link === "function")
                        l = link();
                    kontorouter.goto(l);
                };
            }
        },
        goto: function (link, data) {
            var f = this.getGotoFunction(link, data);
            f();
        },
        _getModalIdFromLink: function (link) {
        	var link = link.toLowerCase();
        		link = link.split('/')
        	
        	if (link.length < 2)
        		return 'modal-'+(new Date()).valueOf().toString();
        		
        	return 'modal-'+link[0]+'-'+link[1];
        },

        /**
         * Koristimo jer provjerava requiresSeletedRow.
         * this - button na kojeg smo kliknuli
         */
        _getClick: function (btn) {
            var that = this;
            var oldClick = btn.click;
            return function () {
                if (oldClick)
                    return oldClick.call(this);
                
                var l = btn.link;
                if (typeof l === "function")
                    l = l();
                that.goto(l);
            };  
        },
        _getNoviClick: function (t) {
            if (t.link)
                return this.getGotoFunction(t.link, {
                    title: "Unos"
                });
            else if (t.click)
                return t.click;
            else
                return function () { console.log("Novi click funkcija nije zadana."); };
        },
        _getIspravakClick: function (t) {
            var that = this;
            if (typeof t.link === "undefined" && typeof t.click !== "function") {
                t.link = that.controller + "/ispravak";
            }
            if (t.link) {
                return function () {
                    var l = t.link;
                    var values = that.grid.kendoKontoGrid("getKeyValues");
            
                    if (values && values.length > 0) {
                        var urlValues = values.join("/");
                        l += "/" + urlValues;
                        that.goto(l, {
                            title: "Ispravak"
                        });
                    }
                };  
            }
            else if (t.click) {
                return t.click;
            }
            else {
                return function () { console.log("Ispravak click funkcija nije zadana."); };
            }
        }, 
              
        /**
         * Funkcije prilagođavamo šifarniku.
         */
        _obradiToolButtone: function (toolbar) {
            if (toolbar) {
                for (var i = 0; i < toolbar.length; ++i) {
                    var t = toolbar[i];
                    if (typeof t === "object") {
                        switch (t.type) {
                        case "novi":
                            t.click = this._getNoviClick(t);
                        break;
                        case "ispravak":
                            t.click = this._getIspravakClick(t);
                        break;
                        //case "filter":
                            //return true;
                            //t.click = this._getFilterPanelClick(t);
                        //break;
                        case "novi-dropdown":
                        case "bnt-dropdown":
                            this._obradiNoviDropdownItems(t);
                        break;
                        case "checkbox":
                            // Click event je dobar takav kakav je.
                        break;
                        default:
                            t.click = this._getClick(t);
                        }
                    }
                }
            }
        },
        /** 
         * Funkcije novi dropdown.
         */
        _obradiNoviDropdownItems: function (dropdown) {
            var items = dropdown.items;
            if (items) {
                for (var i = 0; i < items.length; ++i) {
                    items[i].click = this._getNoviClick(items[i]);
                }
            }
        },
        _onSifarnikOdabir: function(dataItem) {
			if(typeof dataItem === "object")        	
        		dataItem = $.dsObjectToUpperCase(dataItem);
        	
        	var that = this;
            if (typeof dataItem === "undefined") {
                var row = this.kontoGrid.grid.select();
                dataItem = this.kontoGrid.grid.dataItem(row);
                if (dataItem == null)
                    return false;       
            }
            
            if (typeof that.findMethod === "string") {
            	$.dsDirectCall({
            		method: that.findMethod,
            		params: that.kontoGrid.getKeyValues(),
            		success: function(data) {
            			// zbog legacy supporta uppercaseam
            			var upperData = {};
            			$.each(data, function(key, value) {
            				upperData[key.toUpperCase()] = value;
            			});
            			
            			var newObject = $.extend({}, upperData, data);
            			that.div.trigger("onOdabir", newObject);
            		}
            	})		
            }
            else{
            	that.div.trigger("onOdabir", dataItem);
            }
            // Unbind event?
            return true;
        },
        
        _initFilterPanel: function(options) {        	
        	//inicijalizacija filter panela
        	this.filterPanel = new konto.FilterPanel(this, options.filterPanel);
        	
        	//dodajemo 'filter show/hide panel' button u toolbar
        	options.toolbar.push ({
                name: "Filter",
                type: "filter",
                id: "filterPanelBtn-"+this.unique,	
                additionalClass: "filterPanelBtn"
        	});
        	
        	//dodajemo callback funkciju koja vraca json objekt (s vrijednostima filtera) koji se salje na ds
        	if (typeof options.data === 'undefined')
        		options.data = {};

        	options.data.panelFilter = this.filterPanel.getFilterData; //getter
        },
        
        createGrid: function (options) {
            var that = this;
            
            if (this.noviObject)
                options.noviObject = this.noviObject; //{{$smarty.post.object}};
            if (this.title) {
                // Služi kod exporta podataka.
                if (!options.export)
					options.export = {};
                options.export.title = $("#page-title").text();
            }
            
            if (this.getFilter !== null) {
                if (!options.filters) {
                    options.filters = this.getFilter;
                } 
            }
                        
            if (!options.colModel) {
                options.colModel = this.columns;
            }
                  
            if (options.doAfterNotifikacijaProcitana) {
         		konto.Notifikacija.kontoSifarnik = $(that)[0];     				
	           	$(that)[0].mainGrid.attr("data-doAfterNotifikacijaProcitana", options.doAfterNotifikacijaProcitana);
            }            
            
            //inicijalizacija filterPanela ukoliko je on definiran u opcijama sifarnika
            if (typeof options.filterPanel !== 'undefined' && options.filterPanel !== null) {            	
            	this._initFilterPanel(options);
            }            

            if (this.isSifarnik) {
                var data = options.data;
                if (typeof data === "undefined") {
                    data = {};
                }
                if (typeof data["isSifarnik"] === "undefined") {
                    data["isSifarnik"] = "1";
                }

                // Double click na redak u slučaju šifarnika odabire taj redak.
                var userDblClick = options.rowDblClick;
                options.rowDblClick = function (dataItem, e) {
	                $(function () {
					        function checkPendingRequest() { 
					            if ($.active > 0) { 
					                setTimeout(checkPendingRequest, 250);
					            }else{
        		                    if (userDblClick) {
				                        userDblClick.call(this, dataItem, e);
				                    }
				                    if (e.isDefaultPrevented())
				                        return;
				                    
				                    that._onSifarnikOdabir(dataItem);  
					            }
					        };			
				        checkPendingRequest();
					});
                	   
                };
    
                if (!options.toolbar)
                    options.toolbar = [];
                    
                // Dodajemo sifarnik button "Odaberi" i "Odustani" u array.
               	if (typeof options.toolbar === 'function')
                    options.toolbar.concat(that.getSifarnikButtons(options));
              	else
                	options.toolbar = options.toolbar.concat(that.getSifarnikButtons(options));
                
                options.cacheUsage = {
                    filter: false,
                    currentRecord: false
                };
            }
            else {
                if (!options.rowDblClick && options.toolbar) {
                    // Double click na redak poziva ispravak ako nije drugačije definirano.
                    options.rowDblClick = function () {
                        var ispravakBtn = options.toolbar.filter(function (btn) {
                            return btn.type == "ispravak";
                        });
                        if (ispravakBtn.length > 0) {
                            if (typeof ispravakBtn[0].click === "function") {
                                ispravakBtn[0].click.call(this); // Pozivam u istom kontekstu kao i rowDblClick
                            }
                            else {
                                console.log("Button ispravak nema definiran click");
                            }
                        };
                    };
                }     
            }
            //azurirajToolButtone(options.toolbar);
            //options.toolbar = " "; //getToolbar(options.toolbar);
            
            this._obradiToolButtone(options.toolbar);
            options.selValues = this.getValuesFromCache(options.cacheSuffix);
                
            this.kontoGrid = that.grid.kendoKontoGrid(options).data("kendoKontoGrid");
            if (this.isSifarnik) {    
                // Key press - ENTER-om odabiremo
                // Možda opasno ovo globalno...
                var dis = this;
                this.div.closest("div.kontomodal").on("hidden.bs.modal", function () {
                    $("body").off(that.getEventName("keypress"));
                });
                this.div.closest("div.kontomodal").on(that.getEventName("keypress"), function (e) {
                    if (e.keyCode == 13) {
                    	var filPan = $(e.target).closest('#filterPanelContainer-'+dis.unique);
                        if ( !$(".k-textbox").is(":focus") && filPan.length == 0){
                        	$(function () {
						        function checkPendingRequest() { 
						            if ($.active > 0) { 
						                setTimeout(checkPendingRequest, 250);
						            }else{
	                            		return !that._onSifarnikOdabir();
	                            	}
							    };			
						        checkPendingRequest(); 
							});
                        }
                    }
                });
            }
			this.gridArray.push(this.kontoGrid);
        },
		createChildGrid: function(element, options){
			options.selValues = this.getValuesFromCache(options.cacheSuffix);
			var newGrid = element.kendoKontoGrid(options).data("kendoKontoGrid");
			this.gridArray.push(newGrid);
			return newGrid;
		},
        getDigitalnaArhivaButtons: function (options) {
			if (typeof options.kojiMethods === "undefined") {
				var lsKojiMethods = "uz";
				}
			else {
				var lsKojiMethods = options.kojiMethods; // VP, KE, OD, GS, (za novi, ispravak, obriši vezu, dodaj vezu, ...)  
			}
			if (typeof options.kojiMethodsZaPotpis === "undefined") {
				var lsKojiMethodsZaPotpis = "uz";
				}
			else {
				var lsKojiMethodsZaPotpis = options.kojiMethodsZaPotpis; // za sada samo VP, GS (za obriši/arhiviraj potpisnike radi promjene statusa u GS, VP)
			}
			if (typeof options.potpisUDatoteci === "undefined") {
				var lsPotpisUDatoteci = "Dodaj datoteku s potpisom";
				}
			else {
				var lsPotpisUDatoteci = options.potpisUDatoteci; 
			}
			if (typeof options.datotekaZaVrstu === "undefined") {
				var lsDatotekaZaVrstu = "";
				}
			else {
				var lsDatotekaZaVrstu = options.datotekaZaVrstu; 
			}
			if (typeof options.slanjeNaPotpis === "undefined") {
				var lbSlanjeNaPotpis = false
				}
			else {
				var lbSlanjeNaPotpis = options.slanjeNaPotpis; 
			}
			
			if (typeof options.slanjeNaEMail === "undefined") {
				var lbSlanjeNaEMail = false				
			}else {
				var lbSlanjeNaEMail = options.slanjeNaEMail; 
			}
        	
        	// Koje tipke treba prikazati, ovisno o pravima za options.imeTablice
			if (typeof options.dodajPostojece === "undefined") {
				var lbDodajPostojece = false;
				// mislim da ću morati na datasnap po pravo ?!?!
				}
			else {
				var lbDodajPostojece = options.dodajPostojece; 
			}

			if (typeof options.dodajDatotekuSPotpisom === "undefined") {
				var lbDodajDatotekuSPotpisom = true;
				}
			else {
				var lbDodajDatotekuSPotpisom = options.dodajDatotekuSPotpisom; 
			}
			
        	// Koje tipke treba prikazati, ovisno o pravima za options.imeTablice
			if (typeof options.skraceniIzbornik === "undefined") {
				var lbSkraceniIzbornik = false;
				// mislim da ću morati na datasnap po pravo ?!?!
				}
			else {
				var lbSkraceniIzbornik = options.skraceniIzbornik; 
			}

			
			// Maknuti hodogram tipku
			if (typeof options.makniHodogram === "undefined") {
				var lbMakniHodogram = false;
				// mislim da ću morati na datasnap po pravo ?!?!
				}
			else {
				var lbMakniHodogram = options.makniHodogram; 
			}
			
			if (typeof options.vrstaDokUTablici === "undefined") {
				var lsVrstaDokUTablici = "";
				}
			else {
				var lsVrstaDokUTablici = options.vrstaDokUTablici; 
			}					
        	
        	var that = this;
        	var toolbar = [];
        	var itemsD = [];
        	
			if (typeof options.gridZaPodatke === "undefined") {
				var gridZaPodatke = that.grid;
				}
			else {
				var gridZaPodatke = that.div.find(options.gridZaPodatke); 
			}
			
			if (typeof options.prilogUzERacun === "undefined") {
				var lsPrilogUzERacun = "";
				}
			else {
				var lsPrilogUzERacun = options.prilogUzERacun; 
			}

            itemsD.push({
					name: "Pregled datoteke",
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}						
						// Ako je samo jedna onda otvari inače popis						
						if (data.DOKUMENT) {
							var pravoDokDef = that.provjeriPravo("uz/GetPravoNaDokument", data.DOKUMENT, false);
							pravoDokDef.then(function(pravoDok){
								if (!pravoDok) {
									$.dialogGreska({
										title: "Upozorenje",
										content: "Nemate prava na dokument pod brojem " + data.DOKUMENT + ". "
									});
									
								}
								else {
				                    konto.uz.api.BrojDatotekaZaDokument(data.DOKUMENT)
				                        .then(function (brDat) {
				                            if (brDat == 1) {
												//kontorouter.gotoLocation("datoteka/dohvatiPrvu/" + data.DOKUMENT);
						                        konto.uz.api.DohvatiDatotekuIdPrvuZadnju(data.DOKUMENT, 'P').then(function(datObj){
							                    	konto.uz.utils.odradiDohvatiDatoteku(datObj, false); 
							                    });                   
				                            }
				                            else {
												konto.dialogs.sifarnik({
													title: "Popis datoteka za dokument iz digitalne arhive",
													width: "70%",
													template: kontorouter.getModulPath("datoteka/pregledZaDokument/" + data.DOKUMENT + "/" + lsVrstaDokUTablici),
													close: function () {
													}
												});
				                            }
				                    });   
									
								}
							});
						}
						else {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
							
						}
					}
				});
        	
        	itemsD.push({
					name: "Novi dokument/datoteka",
					click: function(){
						var pozivIzIspisaRacuna = $("body").data("pozivIzIspisaRacuna");
						if(pozivIzIspisaRacuna === undefined) {
							pozivIzIspisaRacuna = false;	
						}
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}									
						var pravoNoviDef = that.provjeriPravo("uz/GetDokumentPravoNa", ['NOVI', 0], true);
						pravoNoviDef.then(function(pravo){
							if (pravo) {
								var provjeriZakljucanoDef = $.Deferred();
								if (typeof options.zakljucanoMetoda === "undefined"){
									provjeriZakljucanoDef.resolve(0);	
									}
								else {
									var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
									var arrParam = idVeza.split(";");
									provjeriZakljucanoDef = that.provjeriZakljucano(options.zakljucanoMetoda, arrParam, false);	
								}								
								provjeriZakljucanoDef.then(function(zakljucano){
									if (!zakljucano){
										if (!data.DOKUMENT) { 										
											var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn]+ ';';
											var naziv = typeof options.dokumentNaziv === "function" ? options.dokumentNaziv(data) : "";
											var partner = typeof options.dokumentPartner === "string" ? data[options.dokumentPartner] : 0;
											$.dialog({
												title: "Upis dokumenta u digitalnu arhivu",
												width: "70%",
												template: kontorouter.getModulPath("dokument/unos/" + options.imeTablice + "/" + idVeza + "/" + naziv + "/" + partner + "/0" + "/0" + "/" + lsVrstaDokUTablici + "/" + lsPrilogUzERacun),
												close: function () {
													gridZaPodatke.data("kendoKontoGrid").refresh();
													if(pozivIzIspisaRacuna) {
														konto.vp.utils.osvjeziPrivitkeIzDA(data["GODINA"], data["VRSTA"], data["RACUN"]);	
													}
												}
											});
										}
										else {
											
											var pravoDokDef = that.provjeriPravo("uz/GetPravoNaDokument", data.DOKUMENT, false);
											pravoDokDef.then(function(pravoDok){
												if (!pravoDok) {
													$.dialogGreska({
														title: "Upozorenje",
														content: "Nemate prava na dokument pod brojem " + data.DOKUMENT + ". "
													});													
												}
												else {
													$.dialog({
														title: "Unos datoteka za dokument " + data.DOKUMENT ,
														width: "70%",
														template: kontorouter.getModulPath("datoteka/unos/" + data.DOKUMENT + "/0/0/" + lsPrilogUzERacun),
														close: function () {
															gridZaPodatke.data("kendoKontoGrid").refresh();
															if(pozivIzIspisaRacuna) {
																konto.vp.utils.osvjeziPrivitkeIzDA(data["GODINA"], data["VRSTA"], data["RACUN"]);	
															}															
														}
													});													
												}
											});
										}
									}
								});							
							}
						});
					}					
				});
				
        if (lsDatotekaZaVrstu != "") {				
        	itemsD.push({
					name: lsDatotekaZaVrstu,
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
												
						var dokdatVrsta = (data.DOKDATVRSTA) ? (data.DOKDATVRSTA) : 0;
						
						if (!data.DOKUMENT) {
							
							var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
							var naziv = typeof options.dokumentNaziv === "function" ? options.dokumentNaziv(data) : "";
							var partner = typeof options.dokumentPartner === "string" ? data[options.dokumentPartner] : 0;
							$.dialog({
								title: "Upis dokumenta u digitalnu arhivu",
								width: "70%",
								template: kontorouter.getModulPath("dokument/unos/" + options.imeTablice + "/" + idVeza + "/" + naziv + "/" + partner + "/" + dokdatVrsta + "/0" + "/" + lsVrstaDokUTablici),
								close: function () {
									gridZaPodatke.data("kendoKontoGrid").refresh();
								}
							});
						}
						else {
							var pravoDokDef = that.provjeriPravo("uz/GetPravoNaDokument", data.DOKUMENT, false);
							pravoDokDef.then(function(pravoDok){
								if (!pravoDok) {
									$.dialogGreska({
										title: "Upozorenje",
										content: "Nemate prava na dokument pod brojem " + data.DOKUMENT + ". "
									});
									
								}
								else {
									var pravoNoviDef = that.provjeriPravo("uz/GetDokumentPravoNa", ['ISPRAVAK', data.DOKUMENT], true);
									pravoNoviDef.then(function(pravo){
										if (pravo) {
											var provjeriZakljucanoDef = $.Deferred();
											if (typeof options.zakljucanoMetoda === "undefined"){
												provjeriZakljucanoDef.resolve(0);	
											}else{
												var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
												var arrParam = idVeza.split(";");
												provjeriZakljucanoDef = that.provjeriZakljucano(options.zakljucanoMetoda, arrParam, false);	
											}								
											provjeriZakljucanoDef.then(function(zakljucano){
												if (!zakljucano){
													$.dialog({
														title: lsPotpisUDatoteci + " - unos datoteka za dokument " + data.DOKUMENT,
														width: "70%",
														template: kontorouter.getModulPath("datoteka/unos/" + data.DOKUMENT + "/" + dokdatVrsta + "/0"),
														close: function () {
															gridZaPodatke.data("kendoKontoGrid").refresh();
														}
													});
												}
											});							
										}
									});
									
								}
							});
						}
					}
				});
        	}
        	
        if (lbDodajDatotekuSPotpisom) {				
        	itemsD.push({
					name: lsPotpisUDatoteci,
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
												
						var dokdatVrsta = (data.DOKDATVRSTA) ? (data.DOKDATVRSTA) : 0;
						
						if (!data.DOKUMENT) {
							
							var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
							var naziv = typeof options.dokumentNaziv === "function" ? options.dokumentNaziv(data) : "";
							var partner = typeof options.dokumentPartner === "string" ? data[options.dokumentPartner] : 0;
							$.dialog({
								title: "Upis dokumenta u digitalnu arhivu",
								width: "70%",
								template: kontorouter.getModulPath("dokument/unos/" + options.imeTablice + "/" + idVeza + "/" + naziv + "/" + partner + "/" + dokdatVrsta + "/1" + "/" + lsVrstaDokUTablici),
								close: function () {
									gridZaPodatke.data("kendoKontoGrid").refresh();
								}
							});
						}
						else {
							var pravoDokDef = that.provjeriPravo("uz/GetPravoNaDokument", data.DOKUMENT, false);
							pravoDokDef.then(function(pravoDok){
								if (!pravoDok) {
									$.dialogGreska({
										title: "Upozorenje",
										content: "Nemate prava na dokument pod brojem " + data.DOKUMENT + ". "
									});
									
								}
								else {
									var pravoNoviDef = that.provjeriPravo("uz/GetDokumentPravoNa", ['ISPRAVAK', data.DOKUMENT], true);
									pravoNoviDef.then(function(pravo){
										if (pravo) {
											var provjeriZakljucanoDef = $.Deferred();
											if (typeof options.zakljucanoMetoda === "undefined"){
												provjeriZakljucanoDef.resolve(0);	
											}else{
												var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
												var arrParam = idVeza.split(";");
												provjeriZakljucanoDef = that.provjeriZakljucano(options.zakljucanoMetoda, arrParam, false);	
											}								
											provjeriZakljucanoDef.then(function(zakljucano){
												if (!zakljucano){
													$.dialog({
														title: lsPotpisUDatoteci + " - unos datoteka za dokument " + data.DOKUMENT,
														width: "70%",
														template: kontorouter.getModulPath("datoteka/unos/" + data.DOKUMENT + "/" + dokdatVrsta + "/1"),
														close: function () {
															gridZaPodatke.data("kendoKontoGrid").refresh();
														}
													});
												}
											});							
										}
									});
									
								}
							});
						}
					}
				});
        	}

        	itemsD.push({
                    type: "divider"
               });
               
           	itemsD.push({
					name: "Ispravak podataka o dokumentu",
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}						
						var zakljucanoDef = $.Deferred();
						if (data.DOKUMENT) {
							if (typeof options.zakljucanoMetoda === "undefined") {zakljucanoDef.resolve(0);}
							else {
								var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
								var arrParam = idVeza.split(";");
								zakljucanoDef = that.provjeriZakljucano(options.zakljucanoMetoda, arrParam, false); 
							}
							zakljucanoDef.then(function(zakljucano){
								$.dialog({
									title: "Ispravak podatka o dokumentu",
									width: "70%",
									template: kontorouter.getModulPath("dokument/ispravak/" + data.DOKUMENT + "/" + zakljucano + "/" + lsVrstaDokUTablici + "/" + lsPrilogUzERacun),
									close: function () {
									}
								});
							});				
						}
						else {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
						}
					}
				});
        	
        	itemsD.push({
					name: "Popis datoteka za dokument",
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}						
						if (data.DOKUMENT) {
							konto.dialogs.sifarnik({
								title: "Popis datoteka za dokument iz digitalne arhive " + data.DOKUMENT,
								width: "70%",
								template: kontorouter.getModulPath("datoteka/pregledZaDokument/ " + data.DOKUMENT + "/" + lsVrstaDokUTablici),
								close: function () {
								}
							});
							
						}
						else {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
							
						}
					}
				});
        	
            if (lbDodajPostojece) {
	        	itemsD.push({
						name: "Brisanje veze s dokumentom",
						click: function(){
							var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
							if (!data || data.length === 0) {
								konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
								return;
							}	
							
						    if (!data.DOKUMENT) {
                                $.dialogGreska({
                                    title: "Upozorenje",
                                    content: "Veza ne postoji."
                                });
                            }
                            else{	
    							var pravoBrDef = that.provjeriPravo("uz/GetDokumentPravoNa", ['BRISANJE', data.DOKUMENT] , true);
    							pravoBrDef.then(function(pravo){
                                    if (pravo) {
    									$.dialog({
    										title: "Brisanje veze s dokumentom u digitalnoj arhivi",
    										content: "Obrisati vezu s dokumentom broj " + data.DOKUMENT + " u digitalnoj arhivi?",
    										buttons: {
    											"Da": {
    												isPrimary: true,
    												click: function () {
    													var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn];
    													konto.uz.api.DokumentObrisiVezu(lsKojiMethods, data.DOKUMENT, options.imeTablice, idVeza)
    														.done(function () {
    															gridZaPodatke.data("kendoKontoGrid").refresh();
    													});
    													this.close();
    												}
    											},
    											"Ne": function () {
    												this.close();
    											}
    										}
    									});
    								}
    							});
							}
						}					
					});
				}
				
            if (!lbSkraceniIzbornik) {
				itemsD.push({
						name: "Brisanje dokumenta",
						click: function(){
							var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
							if (!data || data.length === 0) {
								konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
								return;
							}
							if (!data.DOKUMENT) {
								$.dialogGreska({
									title: "Upozorenje",
									content: "Dokument nije u digitalnoj arhivi."
								});
								return;
							}
							var moguceBrDef = konto.uz.api.DokumentMoguceBrisanje(data.DOKUMENT);
							moguceBrDef.then(function(valRes){
								if (valRes.FReturnType == "rtSuccess"){
									$.dialog({
										title: "Brisanje dokumenta u digitalnoj arhivi",
										content: "Obrisati dokument broj " + data.DOKUMENT + " u digitalnoj arhivi?",
										buttons: {
											"Da": {
												isPrimary: true,
												click: function () {
													var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn];
													konto.uz.api.DokumentObrisiVezuIDokument(lsKojiMethods, data.DOKUMENT, options.imeTablice, idVeza)
														.done(function () {
															gridZaPodatke.data("kendoKontoGrid").refresh();
													});
													this.close();
												}
											},
											"Ne": function () {
												this.close();
											}
										}
									});
								}else if (valRes.FReturnType == "rtError"){
						            konto.dialogs.greska({ content: valRes.FErrorMsg });
						        }
							});
						}
					});
				}
        	
            if (lbDodajPostojece) {
	        	itemsD.push({
						name: "Povezivanje s postojećim dok.",
						click: function(){
							var provjeriZakljucanoDef = $.Deferred();
							var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
							if (!data || data.length === 0) {
								konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
								return;
							}
							if (typeof options.zakljucanoMetoda === "undefined"){ 
								provjeriZakljucanoDef.resolve(0); 
							}else{
								var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn] + ';';
								var arrParam = idVeza.split(";");
								provjeriZakljucanoDef = that.provjeriZakljucano(options.zakljucanoMetoda, arrParam, false);	
							}
							if ( (!data.DOKUMENT) ) {
								provjeriZakljucanoDef.then(function(zakljucano){
									if (!zakljucano){
										konto.dialogs.sifarnik({
											title: "Popis dokumenata iz digitalne arhive",
											template: kontorouter.getModulPath("dokument/pregled/" + options.imeTablice),
											odabir: function (dokument) {
												var idVeza = typeof options.dataColumn === "function" ? options.dataColumn(data) : data[options.dataColumn];
												konto.uz.api.DokumentUpisiVezu(lsKojiMethods, dokument.DOKUMENT, options.imeTablice, idVeza)
													.then(function () {														
														gridZaPodatke.data("kendoKontoGrid").refresh();
												});
											}
										});
									}
								});
							}
							else if ((data.DOKUMENT)) {
								$.dialogGreska({
									title: "Upozorenje",
									content: "Veza već postoji."
								});
								
							}
						}
					});
				}
        	
        	
               
            if (lbSlanjeNaPotpis) {
            	itemsD.push({
                    type: "divider"
               });
	           	itemsD.push({
						name: "Pošalji na potpis",
						click: function(){
							var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
							if (!data || data.length === 0) {
								konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
								return;
							}							
							if (data.DOKUMENT) {
								konto.uz.api.GetPravoNaDokument(data.DOKUMENT)
									.then(function (pravo) {
									if (pravo) {  
										var naziv = typeof options.dokumentNaziv === "function" ? options.dokumentNaziv(data) : "";
										
	                                    konto.uz.api.DohvatiDokPotShZaDGrupaKlasaPlan(data.DOKUMENT, data.DGRUPA, 0, '', '')
	                                        .done(function (dataDokPotSh) {
	                                            if (dataDokPotSh.FDokPotSh) {
	                                            	lsPitaj = "Upisati potpisnike prema shemi " + dataDokPotSh.FDokPotSh + " " + dataDokPotSh.FNaziv;
	                                            	lsOJ = (dataDokPotSh.FOrgan) ? " OJ: " + dataDokPotSh.FOrgan : "";
	                                            	lsMT = (dataDokPotSh.FMTroska) ? " MT " + dataDokPotSh.FMTroska : "";
	                                            	
													$.dialog({
														title: "Slanje na potpis (bez generiranja novih PDF datoteka)",
														content: lsPitaj + lsOJ + '' + lsMT + '?',
														buttons: {
															"Da": {
																isPrimary: true,
																click: function () {
																	konto.uz.api.GenPotpisnikePremaShemi(lsKojiMethodsZaPotpis, data.DOKUMENT, dataDokPotSh.FDokPotSh)
																		.done(function () {
																			gridZaPodatke.data("kendoKontoGrid").refresh();
																	});
																	this.close();
																}
															},
															"Ne": function () {
																this.close();
															}
														}
													});
	                                                
	                                            }
	                                    });  
									}
									else {
										$.dialogGreska({
											title: "Upozorenje",
											content: "Nemate potrebna prava na dokument pod brojem " + data.DOKUMENT
										});
									}
								});
							}
							else {
								$.dialogGreska({
									title: "Upozorenje",
									content: "Za slanje na potpis potrebno je dokument upisati u digitalnu arhivu."
								});
							}
						}
					});
				}
				
            if (lbSlanjeNaPotpis) {
	        	itemsD.push({
					name: "Poništi/obriši slanje na potpis",
					click: function(){						
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
						if (!data.DOKUMENT) {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
						}
						else {
							$.dialog({
								title: "Poništavanje slanja na potpis",
								content: "Sigurno želite poništiti (obrisati) potpisnike za dokument " + data.DOKUMENT + " digitalne arhive?",
								buttons: {
									"Da": {
										isPrimary: true,
										click: function () {
											konto.uz.api.DokPotpisObrisi(lsKojiMethodsZaPotpis, 0, data.DOKUMENT)
												.done(function () {
													gridZaPodatke.data("kendoKontoGrid").refresh();
											});
											this.close();
										}
									},
									"Ne": function () {
										this.close();
									}
								}
							});
						}
					}
				});
			}
			
            if (lbSlanjeNaPotpis) {
	        	itemsD.push({
					name: "Poništi/arhiviraj slanje na potpis",
					click: function(){						
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
						if (!data.DOKUMENT) {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
						}
						else {
							$.dialog({
								title: "Poništavanje/arhiviranje slanja na potpis",
								content: "Sigurno želite poništiti (arhivirati) hodogram za dokument " + data.DOKUMENT + " digitalne arhive?",
								buttons: {
									"Da": {
										isPrimary: true,
										click: function () {
											konto.uz.api.DokPotpisArhiviraj(lsKojiMethodsZaPotpis, 0, data.DOKUMENT)
												.done(function () {
													gridZaPodatke.data("kendoKontoGrid").refresh();
											});
											this.close();
										}
									},
									"Ne": function () {
										this.close();
									}
								}
							});
						}
					}
				});
			}			
			if (!lbMakniHodogram){
				itemsD.push({
                    type: "divider"
               });
               itemsD.push({
					name: "Hodogram dokumenta",
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
						if (data.DOKUMENT) {
							konto.uz.api.GetPravoNaDokument(data.DOKUMENT)
								.then(function (pravo) {
								if (pravo) {  
								    konto.uz.api.PostojiHodogramZaDokument(data.DOKUMENT)
                                        .then(function (postojiHodogram) {
                                            if (postojiHodogram){
            									var naziv = typeof options.dokumentNaziv === "function" ? options.dokumentNaziv(data) : "";
            				                    $.dialog({
            				                            title: "Hodogram dokumenta",
            				                            content: "Ispisati hodogram za dokument broj " + data.DOKUMENT + ' - ' + naziv + "?",
            				                            buttons: {
            				                                "Da": {
            				                                    isPrimary: true,
            				                                    click: function () {
            				                                        kontorouter.gotoLocation("dokument/ispisDokumentHod/" + data.DOKUMENT);
            				                                        this.close();
            				                                    }
            				                                },
            				                                "Ne": function () {
            				                                    this.close();
            				                                }
            				                            }
            				                        });
        									}else{
                                                $.dialogGreska({
                                                    title: "Upozorenje",
                                                    content: "Za dokument pod brojem " + data.DOKUMENT + " nema podataka za ispis hodograma!"
                                                }); 
                                            }
                                        });
								}else {
									$.dialogGreska({
										title: "Upozorenje",
										content: "Nemate potrebna prava na dokument pod brojem " + data.DOKUMENT
									});
								}
							});
						}
						else {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Veza prema dokumentu u digitalnoj arhivi ne postoji."
							});
						}
					}
				});
	        	itemsD.push({
					name: "Upiši hodogram u digitalnu arhivu",
					click: function(){						
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
						if (!data.DOKUMENT) {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
						}
						else {
							$.dialog({
								title: "Upis hodograma u digitalnu arhivu",
								content: "Sigurno želite hodogram dokumenta " + data.DOKUMENT + " upisati u digitalnu arhivu?",
								buttons: {
									"Da": {
										isPrimary: true,
										click: function () {
											konto.uz.api.UpisiHodogramUDigitalnu(data.DOKUMENT)
												.done(function () {
													gridZaPodatke.data("kendoKontoGrid").refresh();
											});
											this.close();
										}
									},
									"Ne": function () {
										this.close();
									}
								}
							});
						}
					}
				});				
				itemsD.push({
					name: "Prikaz hodograma",
					click: function(){
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
						if (data.DOKUMENT) {
							konto.uz.api.GetPravoNaDokument(data.DOKUMENT)
								.then(function (pravo) {
								if (pravo) {  
								    konto.uz.api.PostojiHodogramZaDokument(data.DOKUMENT)
                                        .then(function (postojiHodogram) {
                                            if (postojiHodogram){
                                                var naziv = typeof options.dokumentNaziv === "function" ? options.dokumentNaziv(data) : "";
                                                $.dialog({
                                                    title: "Povijest potpisa za dokument " + data.DOKUMENT + ' - ' + naziv,
                                                    template: kontorouter.getModulPath("dokpotpiss/pregledPovijest/") + data.DOKUMENT 
                                                });   
                                            }else{
                                                $.dialogGreska({
                                                    title: "Upozorenje",
                                                    content: "Za dokument pod brojem " + data.DOKUMENT + " nema podataka za ispis hodograma!"
                                                }); 
                                            }
                                        });
								}else {
									$.dialogGreska({
										title: "Upozorenje",
										content: "Nemate potrebna prava na dokument pod brojem " + data.DOKUMENT
									});
								}
							});
						}
						else {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Veza prema dokumentu u digitalnoj arhivi ne postoji."
							});
						}
					}
				});

			}
			if (lbSlanjeNaEMail) {	
				itemsD.push({
					type: "divider"
				});
				itemsD.push({
					name: "Slanje e-maila",
					click: function(){						
						var data = gridZaPodatke.kendoKontoGrid("getSelectedData");
						if (!data || data.length === 0) {
							konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
							return;
						}
						if (!data.DOKUMENT) {
							$.dialogGreska({
								title: "Upozorenje",
								content: "Dokument nije u digitalnoj arhivi."
							});
						}
						else {							
							var pravoDokDef = that.provjeriPravo("uz/GetPravoNaDokument", data.DOKUMENT, false);
							pravoDokDef.then(function(pravoDok){
								if (!pravoDok) {
									$.dialogGreska({
										title: "Upozorenje",
										content: "Nemate prava na dokument pod brojem " + data.DOKUMENT + ". "
									});
									
								}
								else {
									li = kontorouter.getModulPath("dokument/email/" + data.DOKUMENT); 
			                        var modal = konto.dialogs.modal({
			                            title: "Slanje datoteka na e-mail",
			                            width: "70%",
			                            template: li,
			                            templateLoaded: function () {
						                    modal.element.find("form").on("onUpis", function (event, data) {
												KUtils.busy(false);
												konto.dialogs.obradiValidatorRes(data);
						                    }); 
						                },
			                        });	
								}
							});							
						}
					}
				});			
			}	
		
        	toolbar.push({
				type: "dropdown",
				classes: "dropdown btnDokumenti",
				name: "Dokumenti",
                ikona: "fas fa-database",				
				items: itemsD
			});
			
			return toolbar;
        }
    });
} (jQuery, window.konto = window.konto || {}));